import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import {
  NoopAnimationsModule,
  BrowserAnimationsModule
} from '@angular/platform-browser/animations';

import { MainRoutes, MainRoutingModule } from './main.routing';
import { MainComponent } from './main.component';
import { RouterModule, Routes, Router } from '@angular/router';

import { HttpClientModule } from '@angular/common/http';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { JasperoConfirmationsModule } from '@systemic/ng-confirmations';
import { JasperoAlertsModule } from '@jaspero/ng-alerts';
import { CookieModule } from 'ngx-cookie';
import { UtilitesService, HttpService, ErrorLogService } from '@systemic/services';
import { AppLayoutModule } from 'app/@layout/app-layout.module';
import { AppRoutingModule } from 'app/app.routing';
import { AuthModule } from 'auth/auth.module';
import { GlobalErrorHandler } from '@systemic/handlers/error-handler';
import { RouterExtService } from '@systemic/services/router/router-ext.service';
import { SelectGuruModule } from '@systemic/select-guru';
import { AppGuard } from '@systemic/guard';
import { AuthService } from '@service/auth/auth.service';
import { SystemicModule } from '@systemic/systemic.module';
@NgModule({
  declarations: [MainComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MainRoutingModule,
    HttpClientModule,
    SimpleNotificationsModule.forRoot(),
    JasperoConfirmationsModule.forRoot(),
    JasperoAlertsModule.forRoot(),
    CookieModule.forRoot(),
    RouterModule,
    AppLayoutModule,
    AppRoutingModule,
    SelectGuruModule
  ],
  providers: [UtilitesService, HttpService, RouterExtService, ErrorLogService, AppGuard, AuthService, {
    provide: ErrorHandler, useClass: GlobalErrorHandler
  }],
  bootstrap: [MainComponent]
})
export class MainModule { }



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/main.module.ts